// extracted by mini-css-extract-plugin
export default {"amount-per-serving":"RdpModalFromPairingId-module__amount-per-serving__ao3Ir","secondary":"RdpModalFromPairingId-module__secondary__T4npl"};